import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class HelpCentreService {
  private readonly http = inject(HttpClient);

  /**
   * Opens a Help Centre article in a new tab.
   * Requests a fresh token on every call — tokens are single-use.
   *
   * @param articleSlug  The WP article slug, e.g. "getting-started".
   */
  openArticle(articleSlug: string): void {
    const tokenUrl = `${environment.serverUrl}/auth/helpCentreToken`;
    const dest = encodeURIComponent(`/${articleSlug}`);
    this.http.get<{ token: string }>(tokenUrl).subscribe({
      next: ({ token }) => {
        const url =
          `${environment.helpCentreBase}/` +
          `?esqep_sso=1&esqep_token=${encodeURIComponent(token)}&dest=${dest}`;
        window.open(url, '_blank', 'noopener,noreferrer');
      },
      error: () =>
        window.open(
          environment.helpCentreFallbackUrl,
          '_blank',
          'noopener,noreferrer',
        ),
    });
  }
}
